// src/components/lead/sections/GhlLocationMismatchModal.tsx
import type { Lead } from "@/types/lead";
import type { Location } from "@/types/location";

export function GhlLocationMismatchModal(props: {
  lead: Lead | null;
  workspaceLocation: Location | null;
  originLocation: Location | null;
  onSendWithOrigin: () => void;
  onSendWithCurrentWorkspace: () => void;
  onCancel: () => void;
}) {
  const { lead, workspaceLocation, originLocation, onSendWithOrigin, onSendWithCurrentWorkspace, onCancel } =
    props;

  if (!lead || !originLocation) return null;

  const wsName = workspaceLocation?.name?.trim() || "your current workspace location";
  const originName =
    (originLocation.name || "").trim() || (lead.origin_location_name || "").trim() || "origin location";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="bg-white dark:bg-slate-900 dark:border dark:border-slate-600 rounded-2xl shadow-2xl max-w-md w-full p-6 text-left">
        <h2 className="text-lg font-bold text-gray-900 dark:text-slate-100 mb-2">Location differs from lead origin</h2>
        <p className="text-sm text-gray-700 dark:text-slate-300 mb-3">
          This lead was captured for{" "}
          <span className="font-semibold text-gray-900 dark:text-slate-100">{originName}</span>, but your workspace is
          set to <span className="font-semibold text-gray-900 dark:text-slate-100">{wsName}</span>. Go High Level will
          receive the location you choose below.
        </p>
        <div className="space-y-2 mt-4">
          <button
            type="button"
            className="w-full py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
            onClick={onSendWithOrigin}
          >
            Send using origin location ({originName})
          </button>
          <button
            type="button"
            className="w-full py-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-slate-100 text-sm font-semibold hover:bg-slate-200 dark:hover:bg-slate-700"
            onClick={onSendWithCurrentWorkspace}
          >
            Send using current workspace ({wsName})
          </button>
          <button
            type="button"
            className="w-full py-2 rounded-xl text-sm text-gray-600 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-800"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
